var BRAND = {
  CZR: 'czr',
  CZR_PR: 'czr-pr',
  CZR_WA_MS: 'czr-wa-ms',
  CZR_MS: 'czr-ms',
  WH: 'wh',
  CZR_CASINO: 'czr-casino',
  HORSESHOE: 'horseshoe',
  NFT: 'nft',
  CZR_UAT: 'czr-uat',
  CZR_CASINO_UAT: 'czr-casino-uat'
};
var GEOCOMPLY_PLC_VERSION = '4.0.0.4';
module.exports = {
  BRAND: BRAND,
  ENV: {
    DEV: 'dev',
    TEST: 'test',
    CERT: 'cert',
    INTERNALPROD: 'internalprod',
    PROD: 'prod'
  },
  ENV_GEN_PLATFORMS: ['desktop', 'ios', 'android'],
  GEOCOMPLY_PLC_VERSION: GEOCOMPLY_PLC_VERSION,
  REGION: {
    AZ: 'az',
    CO: 'co',
    DC: 'dc',
    IA: 'ia',
    IL: 'il',
    IN: 'in',
    ME: 'me',
    MA: 'ma',
    MI: 'mi',
    MD: 'md',
    MS: 'ms',
    NC: 'nc',
    NJ: 'nj',
    PA: 'pa',
    PR: 'pr',
    TN: 'tn',
    VA: 'va',
    WV: 'wv',
    NV: 'nv',
    OH: 'oh',
    ON: 'on',
    KS: 'ks',
    KY: 'ky',
    'WA-MS': 'wa-ms',
    'WA-SK': 'wa-sk',
    'NF1': 'nf1',
    'NF2': 'nf2'
  },
  CANADA_REGIONS: ['ab', 'bc', 'mb', 'nb', 'nl', 'nt', 'ns', 'nu', 'on', 'pe', 'qc', 'sk', 'yt'],
  DOMAIN_OVERRIDE: {
    dev: {
      czr: {
        l5y: {
          APP_URL: 'https://czr.usd.l5y.app'
        },
        martech: {
          APP_URL: 'https://martech.usd.l5y.app'
        },
        bop: {
          APP_URL: 'https://bop.usd.l5y.app'
        },
        retail: {
          APP_URL: 'https://retail.usd.l5y.app'
        },
        sportsbook: {
          APP_URL: 'https://sportsbook.usd.l5y.app'
        },
        'czr-master': {
          APP_URL: 'https://czr-master.usd.l5y.app'
        }
      },
      'czr-pr': {
        l5y: {
          APP_URL: 'https://czr.usd.l5y.app'
        }
      },
      'czr-wa-ms': {
        l5y: {
          APP_URL: 'https://czr.usd.l5y.app'
        }
      },
      'czr-ms': {
        l5y: {
          APP_URL: 'https://czr.usd.l5y.app'
        }
      },
      wh: {
        l5y: {
          APP_URL: 'https://wh.usd.l5y.app'
        }
      },
      'czr-casino': {
        l5y: {
          APP_URL: 'https://czr-casino.usd.l5y.app'
        }
      },
      horseshoe: {
        l5y: {
          APP_URL: 'https://czr-casino.usd.l5y.app'
        },
        test: {
          APP_URL: 'https://test.usd.l5y.app'
        }
      }
    },
    test: {
      czr: {
        l5y: {
          APP_URL: 'https://czr.gpt.l5y.app'
        },
        martech: {
          APP_URL: 'https://martech.gpt.l5y.app'
        },
        bop: {
          APP_URL: 'https://bop.gpt.l5y.app'
        },
        retail: {
          APP_URL: 'https://retail.gpt.l5y.app'
        },
        sportsbook: {
          APP_URL: 'https://sportsbook.gpt.l5y.app'
        },
        'czr-master': {
          APP_URL: 'https://czr-master.gpt.l5y.app'
        }
      },
      'czr-pr': {
        l5y: {
          APP_URL: 'https://czr.gpt.l5y.app'
        },
        retail: {
          APP_URL: 'https://retail.gpt.l5y.app'
        }
      },
      'czr-wa-ms': {
        l5y: {
          APP_URL: 'https://czr.gpt.l5y.app'
        },
        retail: {
          APP_URL: 'https://retail.gpt.l5y.app'
        }
      },
      'czr-ms': {
        l5y: {
          APP_URL: 'https://czr.gpt.l5y.app'
        },
        retail: {
          APP_URL: 'https://retail.gpt.l5y.app'
        }
      },
      wh: {
        l5y: {
          APP_URL: 'https://wh.gpt.l5y.app'
        },
        retail: {
          APP_URL: 'https://retail.gpt.l5y.app'
        }
      },
      'czr-casino': {
        l5y: {
          APP_URL: 'https://czr-casino.gpt.l5y.app'
        },
        'cpo-master': {
          APP_URL: 'https://cpo-master.gpt.l5y.app'
        }
      },
      horseshoe: {
        l5y: {
          APP_URL: 'https://horseshoe.gpt.l5y.app'
        },
        'horseshoe-master': {
          APP_URL: 'https://horseshoe-master.gpt.l5y.app'
        }
      }
    },
    cert: {
      czr: {
        l5y: {
          APP_URL: 'https://czr.usc.l5y.app'
        },
        martech: {
          APP_URL: 'https://martech.usc.l5y.app'
        },
        bop: {
          APP_URL: 'https://bop.usc.l5y.app'
        },
        retail: {
          APP_URL: 'https://retail.usc.l5y.app'
        },
        sportsbook: {
          APP_URL: 'https://sportsbook.usc.l5y.app'
        },
        'czr-master': {
          APP_URL: 'https://czr-master.usc.l5y.app'
        }
      },
      'czr-pr': {
        l5y: {
          APP_URL: 'https://czr.usc.l5y.app'
        }
      },
      'czr-wa-ms': {
        l5y: {
          APP_URL: 'https://czr.usc.l5y.app'
        }
      },
      'czr-ms': {
        l5y: {
          APP_URL: 'https://czr.usc.l5y.app'
        }
      },
      wh: {
        l5y: {
          APP_URL: 'https://wh.usc.l5y.app'
        }
      },
      'czr-casino': {
        l5y: {
          APP_URL: 'https://czr-casino.usc.l5y.app'
        },
        'cpo-master': {
          APP_URL: 'https://cpo-master.usc.l5y.app'
        }
      },
      horseshoe: {
        l5y: {
          APP_URL: 'https://horseshoe.usc.l5y.app'
        },
        'horseshoe-master': {
          APP_URL: 'https://horseshoe-master.usc.l5y.app'
        }
      },
      nft: {
        l5y: {
          APP_URL: 'https://czr.usc.l5y.app'
        }
      }
    },
    internalprod: {
      czr: {
        l5y: {
          APP_URL: 'https://czr.internalprod.americanwagering.com'
        },
        'czr-master': {
          APP_URL: 'https://czr-master.internalprod.americanwagering.com'
        }
      },
      'czr-uat': {
        l5y: {
          APP_URL: 'https://czr-uat.internalprod.americanwagering.com'
        }
      },
      'czr-pr': {
        l5y: {
          APP_URL: 'https://czr.internalprod.americanwagering.com'
        }
      },
      'czr-wa-ms': {
        l5y: {
          APP_URL: 'https://czr.internalprod.americanwagering.com'
        }
      },
      'czr-ms': {
        l5y: {
          APP_URL: 'https://czr.internalprod.americanwagering.com'
        }
      },
      wh: {
        l5y: {
          APP_URL: 'https://wh.internalprod.americanwagering.com'
        }
      },
      'czr-casino': {
        l5y: {
          APP_URL: 'https://czr-casino.internalprod.americanwagering.com'
        }
      },
      'czr-casino-uat': {
        l5y: {
          APP_URL: 'https://czr-casino-uat.internalprod.americanwagering.com'
        }
      },
      horseshoe: {
        l5y: {
          APP_URL: 'https://horseshoe.internalprod.americanwagering.com'
        }
      }
    },
    prod: {
      czr: {
        l5y: {
          APP_URL: 'https://sportsbook.caesars.com'
        }
      },
      'czr-pr': {
        l5y: {
          APP_URL: 'https://sportsbook.caesars.com'
        }
      },
      'czr-wa-ms': {
        l5y: {
          APP_URL: 'https://sportsbook.caesars.com'
        }
      },
      'czr-ms': {
        l5y: {
          APP_URL: 'https://sportsbook.caesars.com'
        }
      },
      wh: {
        l5y: {
          APP_URL: 'https://williamhill.us'
        }
      },
      'czr-casino': {
        l5y: {
          APP_URL: 'https://caesarspalaceonline.com'
        }
      },
      horseshoe: {
        l5y: {
          APP_URL: 'https://horseshoeonlinecasino.com'
        }
      }
    }
  },
  ENV_MAPPING: {
    dev: 'usd',
    test: 'gpt',
    cert: 'usc',
    internalprod: 'usp-internal',
    prod: 'usp'
  },
  AMERICANWAGERING_STATES: {
    dev: 'all',
    test: ['on', 'wy', 'pa', 'dc', 'oh', 'ks', 'ky', 'me', 'md', 'co', 'ma', 'nc', 'ms', 'wa-sk', 'wa-ms', 'pr'],
    cert: ['on', 'wy', 'pa', 'dc', 'oh', 'ks', 'ky', 'me', 'md', 'co', 'ma', 'nc', 'ms', 'wa-sk', 'wa-ms', 'pr', 'nf1', 'nf2', 'nf3'],
    internalprod: ['on', 'wy', 'pa', 'dc', 'oh', 'ks', 'ky', 'me', 'md', 'co', 'ma', 'nc', 'ms', 'wa-sk', 'wa-ms', 'pr'],
    prod: ['on', 'wy', 'pa', 'dc', 'oh', 'ks', 'ky', 'me', 'md', 'co', 'ma', 'nc', 'ms', 'wa-sk', 'wa-ms', 'pr']
  },
  PAM_STATES: {
    dev: ['wy', 'co'],
    test: ['wy', 'co'],
    cert: ['wy', 'nf2', 'nf3', 'co'],
    internalprod: ['wy', 'co'],
    prod: ['wy', 'co']
  },
  STATE_ABBREV_TO_FULLNAME: {
    al: "Alabama",
    ak: "Alaska",
    az: "Arizona",
    ar: "Arkansas",
    bs: 'Bahamas',
    ca: "California",
    co: "Colorado",
    ct: "Connecticut",
    de: "Delaware",
    dc: "District of Columbia",
    fl: "Florida",
    ga: "Georgia",
    hi: "Hawaii",
    id: "Idaho",
    il: "Illinois",
    in: "Indiana",
    ia: "Iowa",
    ks: "Kansas",
    ky: "Kentucky",
    la: "Louisiana",
    me: "Maine",
    md: "Maryland",
    ma: "Massachusetts",
    mi: "Michigan",
    mn: "Minnesota",
    ms: "Mississippi",
    mo: "Missouri",
    mt: "Montana",
    ne: "Nebraska",
    nv: "Nevada",
    nh: "New Hampshire",
    nj: "New Jersey",
    nm: "New Mexico",
    ny: "New York",
    'nf1': "Non Functional 1",
    'nf2': "Non Functional 2",
    nc: "North Carolina",
    nd: "North Dakota",
    oh: "Ohio",
    ok: "Oklahoma",
    on: "Ontario",
    or: "Oregon",
    pa: "Pennsylvania",
    pr: "Puerto Rico",
    ri: "Rhode Island",
    sc: "South Carolina",
    sd: "South Dakota",
    tn: "Tennessee",
    tx: "Texas",
    ut: "Utah",
    vt: "Vermont",
    va: "Virginia",
    'wa-ms': "Washington Muckleshoot",
    'wa-sk': "Washington Spokane",
    wv: "West Virginia",
    wi: "Wisconsin",
    wy: "Wyoming"
  },
  L5Y_WITH_LEGACY_DIFFUSION: [],
  L5Y_WITH_LEGACY_DIFFUSION_BET_REFERRAL: ['co'],
  TR_BRANDS: [BRAND.CZR_NV, BRAND.WH, BRAND.CZR_PR, BRAND.CZR_WA_MS, BRAND.CZR_MS],
  SELFIE_FLOW_STATES: ['nv'],
  ONSITE_FLOW_STATES: ['wa-ms', 'pr'],
  TR_STATES: ['nv', 'wa-ms', 'pr'],
  CONTENTSTACK_ENV_MAP: {
    dev: 'development',
    test: 'testing',
    cert: 'cert',
    internalprod: 'website',
    prod: 'website'
  },
  STANDALONE_APP_REQUIRED_REGIONS: {
    'czr-pr': ['pr'],
    wh: ['nv'],
    'czr-wa-ms': ['wa-ms'],
    'czr-ms': ['ms']
  }
};